import { shopifyAppSetupUrl, shopifyAppUrl } from './platform-links';

export function getShopifyAppLink(storeId: string) {
  return shopifyAppUrl(storeId);
}

/** Falls back to the Shopify admin home when the connected store is unknown. */
export function getShopifyAppSetupLink(storeId: string | undefined) {
  return shopifyAppSetupUrl(storeId);
}
